// Core interfaces
export * from './user.interface';
export * from './project.interface';
export * from './project-file.interface';
export * from './project-invite.interface';
export * from './global-role.interface';
export * from './capability-grant.interface';
export * from './connection.interface';
export * from './step/step.interface';
export * from './step-type.interface';
export * from './snapshot.interface';
export * from './routine.interface';
export * from './exec.interface';
export * from './search.interface';
export * from './import.interface';
export * from './cache.interface';

// Enum types
export * from './enums.interface';

// Request/Response types
export * from './request-response.interface';

// Execution plan interfaces (aligned with server API)
export {
  type ExecPlan,
  type ExecPlanAndJob,
  type CreatePlanRequest,
  type UpdatePlanRequest,
  type CreateJobRequest,
  type TriggerRoutineRequest,
  type RetryJobRequest,
  type JobListParams,
  JobListSortColumns,
  AcknowledgmentState,
  type RoutineValidationResponse,
  type RoutineStats,
  type RoutineHistoryItem,
  type JobStatusSummary,
  type JobAcknowledgment,
  type UpdateAcknowledgmentRequest,
  type StepErrorDetails,
  type JobDetailResponse,
  ReviewDecision,
  type JobReview,
  type ReviewRequest,
  StepMatchType,
  type DiffStepErrorSummary,
  type StepSide,
  type StepDiff,
  type JobSide,
  type JobDiffResponse,
} from './execution-plan.interfaces';

// File interfaces (UI-specific, extends base types)
export {
  type ProjectFileUI,
  type ProjectFileItem
} from './file.interface';

// Workflow interfaces
export {
  type Workflow,
  type FullWorkflow,
  type WorkflowCache,
  type WorkflowFile,
  type WorkflowDefaultFile,
  type WorkflowResult,
  type WorkflowResultWithSummary,
  type NotebookCache,
  type NotebookFile
} from './workflow.interface';

// Secrets interfaces (UI-specific request/response types)
export {
  type Secret,
  type SecretSource,
  type CreateSecretSourceRequest,
  type UpdateSecretSourceRequest,
  type CreateSecretRequest,
  type UpdateSecretRequest,
  type SecretSourceConfig
} from './secrets.interface';

// Other shared interfaces
export * from './create-dialog.interface';
export * from './runtime.interface';
export * from './global-var.interface';
export * from './table-result.interface';
export * from './canvas.interface';
export * from './shared.interface';
export * from './table-column.interface';
export * from './websocket.interface';
export * from './display-message.interface';
export * from './environment.interface';
export * from './errors.interface';
export * from './arquero-table.interface';
export * from './project-constants.interface';
export * from './object-storage.interface';
export * from './oauth-storage.interface';
export * from './push-destination.interface';

// Notification interfaces
// Note: Some types may conflict with rt-messaging.generated
// export * from './notification.interface';

// CDN Module interfaces
// Note: Some types may conflict with other interfaces
// export * from './cdn-module.interface';

// Generated types (selective to avoid conflicts)
export type {
  GetEntriesParams,
  ErrorType,
  ErrorDetails,
  ChannelWithEvents,
  SubscriptionInfo,
  EntryInfo,
  CurrentEditorInfo,
  ListChannels,
  ListSubscriptions,
  Subscribe,
  Unsubscribe,
  GetEntries,
  MarkSeen,
  WatchEditors,
  LockEditor,
  UnlockEditor,
  ChannelList,
  SubscriptionList,
  Subscribed,
  Unsubscribed,
  NewEntries,
  Entries,
  Marked,
  CurrentEditorResponse,
  Complete,
  Empty
} from './rt-messaging.generated';
